import { z } from "zod";

export enum SubscriptionInitiatedByType {
  CUSTOMER = "CUSTOMER",
  ADMIN = "ADMIN",
}

export interface IInitiatedByOption {
  value: SubscriptionInitiatedByType;
  label: string;
}

export const assignPartnerToSubscriptionSessionsRequestSchema = z.object({
  partnerId: z.string().uuid("Invalid partner"),
  overrideAssigned: z.boolean({
    required_error: "overrideAssigned is required",
  }),
});

export const assignPartnerToSubscriptionSessionsResponseSchema = z.object({
  assignedCount: z.number(),
  skippedCount: z.number(),
  sessionIds: z.array(z.string().uuid()),
});

export type IAssignPartnerToSubscriptionSessionsRequest = z.infer<
  typeof assignPartnerToSubscriptionSessionsRequestSchema
>;
export type IAssignPartnerToSubscriptionSessionsResponse = z.infer<
  typeof assignPartnerToSubscriptionSessionsResponseSchema
>;

export const unassignPartnerFromSubscriptionSessionsResponseSchema = z.object({
  unassignedCount: z.number(),
  sessionIds: z.array(z.string().uuid()),
});

export type IUnassignPartnerFromSubscriptionSessionsResponse = z.infer<
  typeof unassignPartnerFromSubscriptionSessionsResponseSchema
>;

export const startSubscriptionAssignmentRequestRequestSchema = z.object({});

export const startSubscriptionAssignmentRequestResponseSchema = z.object({
  sessionCount: z.number(),
  jobId: z.string().nullable(),
});

export type IStartSubscriptionAssignmentRequestRequest = z.infer<
  typeof startSubscriptionAssignmentRequestRequestSchema
>;
export type IStartSubscriptionAssignmentRequestResponse = z.infer<
  typeof startSubscriptionAssignmentRequestResponseSchema
>;

export enum SubscriptionCancellationReason {
  ADMIN_CUSTOMER_TOO_EXPENSIVE = "ADMIN_CUSTOMER_TOO_EXPENSIVE",
  ADMIN_CUSTOMER_MOVING_TO_NEW_LOCATION = "ADMIN_CUSTOMER_MOVING_TO_NEW_LOCATION",
  ADMIN_CUSTOMER_DOG_HEALTH_ISSUES = "ADMIN_CUSTOMER_DOG_HEALTH_ISSUES",
  ADMIN_CUSTOMER_NOT_SATISFIED_WITH_SERVICE = "ADMIN_CUSTOMER_NOT_SATISFIED_WITH_SERVICE",
  ADMIN_CUSTOMER_FOUND_ANOTHER_SOLUTION = "ADMIN_CUSTOMER_FOUND_ANOTHER_SOLUTION",
  ADMIN_CUSTOMER_OTHER = "ADMIN_CUSTOMER_OTHER",
  ADMIN_SUPPLY_ISSUE = "ADMIN_SUPPLY_ISSUE",
  ADMIN_OTHERS = "ADMIN_OTHERS",
}
